export const navLinks = [
  { label: 'Avantages', href: '/#solutions' },
  { label: 'Fonctionnalités', href: '/#fonctionnalites' },
  { label: 'Facturation Électronique', href: '/#facturation-electronique' },
  { label: 'Témoignages', href: '/#clients' },
  { label: 'Tarif', href: '/#tarif' },
  { label: 'Newsletter', href: '/newsletters' },
  { label: 'Accès Client', href: 'https://client.zlawyer.fr/sign-in', target: '_blank' },
];
